<template>
<div>
    <el-card>
    <template v-slot:header>
        <div class="clearfix">
        <span style="font-weight: bold;"><i class="icon iconfont icon-sangjitu" style="font-weight: bold;margin-right: 5px;"></i>TFBS-Enhancers-Gene Network</span>
        <el-button @click="loadNextData" type="primary" size="small" class="custom-button1">Next Page </el-button>
        <el-button @click="loadPreviousData" type="primary" size="small" class="custom-button2">Previous Page</el-button>
        </div>
    </template>
    <div id="chart-container" style="width: 100%; height: 500px;"></div>
    </el-card>
</div>
</template>

<script>
export default {
props: {
    species: {
        type: String,
        required: true,
    },
    tissue: {
        type: String,
        required: true,
    },
},
data() {
    return {
    sankeyData: null,
    url: "http://183.175.59.4/devenhancer/", // 后端接口地址
    pageIndex: 0, // 当前展示数据的页索引
    pageSize: 10, // 每页展示的数据条数
    totalPage: 0, // 总页数
    $chart: null, // ECharts 图表实例
    };
},
mounted() {
    this.loadSankeyData();
},
methods: {
    loadSankeyData() {
    const params = {
        Species: this.species,
        Tissue: this.tissue,
        page: this.pageIndex + 1, // 页码从1开始计算
        pageSize: this.pageSize,
    };
    // 发送GET请求并获取数据
    this.$axios
        .get(this.url + "tfbsgene" + "/", { params })
        .then((response) => {
        const data = response.data.slice(
            this.pageIndex * this.pageSize,
            (this.pageIndex + 1) * this.pageSize
        );

        // 构建 nodes 和 links 数组
        const nodes = [];
        const links = [];

        data.forEach((item) => {
        // 添加 Teid、Tfbs 和 Gene 到 nodes
        if (item.Tfbs && item.Gene) {  // 过滤掉 Tfbs 和 Gene 列为空的数据
            if (!nodes.find((node) => node.name === item.Teid)) {
                nodes.push({ name: item.Teid });
            }
            if (!nodes.find((node) => node.name === item.Tfbs)) {
                nodes.push({ name: item.Tfbs });
            }
            if (!nodes.find((node) => node.name === item.Gene)) {
                nodes.push({ name: item.Gene });
            }

            links.push({
                source: item.Tfbs,
                target: item.Teid,
                value: 1,
            });
            links.push({
                source: item.Teid,
                target: item.Gene,
                value: 1,
            });
        }
    });

        // 更新桑基图的配置项
        this.sankeyData = {
            nodes,
            links,
        };

        this.renderSankeyChart();
        this.totalPage = Math.ceil(response.data.length / this.pageSize); // 计算总页数
        })
        .catch((error) => {
        console.error(error);
        });
    },

    renderSankeyChart() {
    // 销毁之前的图表实例
    if (this.$chart) {
        this.$chart.dispose();
    }

    // 创建新的图表实例
    this.$chart = this.$echarts.init(
        document.getElementById("chart-container")
    );

    // 设置桑基图的配置项
    const options = {
        series: [
        {
            type: "sankey",
            layout: "none",
            data: this.sankeyData.nodes,
            links: this.sankeyData.links,
            itemStyle: {
            borderWidth: 1,
            borderColor: "#aaa",
            },
            lineStyle: {
            color: "source",
            curveness: 0.5,
            },
            label: {
            position: "right",
            formatter: "{b}",
            },
        },
        ],
    };
    // 使用配置项绘制桑基图
    this.$chart.setOption(options);
    },

    loadNextData() {
    if (this.pageIndex < this.totalPage - 1) {
        this.pageIndex++; // 增加页索引
        this.loadSankeyData();
    }
    },

    loadPreviousData() {
    if (this.pageIndex > 0) {
        this.pageIndex--; // 减少页索引
        this.loadSankeyData();
    }
    },
},
};
</script>

<style scoped>
.custom-button1 {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #F1F7E7; /* 设置文字颜色为白色，以提高对比度 */
}
.custom-button2 {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #F1F7E7; /* 设置文字颜色为白色，以提高对比度 */
    margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/relationship1/Shipfig1.vue